import type { SVGProps } from "react";

export const SiteImprovementAllowancesIcon = ({
  width = "14",
  height = "8",
  props,
}: {
  width?: string;
  height?: string;
  props?: SVGProps<SVGSVGElement>;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 8"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.25 0.4375C8.93934 0.4375 8.6875 0.68934 8.6875 1C8.6875 1.31066 8.93934 1.5625 9.25 1.5625H11.642L8.85225 4.35225C8.51142 4.69308 8.29053 4.91264 8.10686 5.05707C7.93325 5.19359 7.85122 5.21467 7.80046 5.21924C7.76689 5.22227 7.73311 5.22227 7.69954 5.21924C7.64878 5.21467 7.56675 5.19359 7.39314 5.05707C7.20947 4.91264 6.98858 4.69308 6.64775 4.35225L6.62474 4.32924C6.31346 4.01794 6.04514 3.74959 5.80227 3.5586C5.54337 3.35501 5.25682 3.19231 4.90139 3.16029C4.80067 3.15122 4.69933 3.15122 4.59861 3.1603C4.24318 3.19231 3.95663 3.35501 3.69773 3.5586C3.45486 3.74959 3.18653 4.01794 2.87525 4.32926L0.602252 6.60225C0.382583 6.82192 0.382583 7.17808 0.602252 7.39775C0.821922 7.61742 1.17808 7.61742 1.39775 7.39775L3.64775 5.14775C3.98858 4.80692 4.20947 4.58736 4.39314 4.44293C4.56675 4.30641 4.64878 4.28533 4.69953 4.28076C4.73311 4.27773 4.76689 4.27773 4.80047 4.28076C4.85122 4.28533 4.93325 4.30641 5.10686 4.44293C5.29053 4.58736 5.51142 4.80692 5.85225 5.14775L5.87526 5.17076L5.87527 5.17076C6.18654 5.48207 6.45486 5.75041 6.69773 5.9414C6.95663 6.14499 7.24318 6.30769 7.59861 6.3397C7.69933 6.34878 7.80067 6.34878 7.90139 6.3397C8.25682 6.30769 8.54337 6.14499 8.80227 5.9414C9.04514 5.75042 9.31345 5.48207 9.62473 5.17077L9.62473 5.17076L12.4375 2.358V4.75C12.4375 5.06066 12.6893 5.3125 13 5.3125C13.3107 5.3125 13.5625 5.06066 13.5625 4.75V1C13.5625 0.856044 13.5076 0.712087 13.3977 0.602252C13.3438 0.548322 13.2817 0.507632 13.2153 0.480182C13.149 0.452679 13.0763 0.4375 13 0.4375H9.25Z"
      fill="currentColor"
    />
  </svg>
);
